import { useEffect, useContext } from "react";
import Messages from "../../../constant/Messages";
import { SnackbarContext } from "../../../contexts/SnackbarContext";

const NetworkStatusMonitor = () => {
  const { showSnackbar } = useContext(SnackbarContext);

  useEffect(() => {
    const notifyOffline = () => {
      showSnackbar({
        severity: "error",
        message: Messages.ERROR.NETWORK_ERROR,
      });
    };

    if (!navigator.onLine) {
      notifyOffline();
    }

    const handleOnline = () => {
      showSnackbar({
        severity: "success",
        message: Messages.NETWORK.ONLINE,
      });
      const snackbarDisplayTime = 1000;
      setTimeout(() => {
        window.location.reload();
      }, snackbarDisplayTime);
    };

    const handleOffline = () => {
      notifyOffline();
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [showSnackbar]);

  return null;
};

export default NetworkStatusMonitor;